// Every user-facing date in Mimique, written the one way: dd/mm/yy.
//
// Before this there were four formats in play — "3 September 2026" on the blog,
// "3 Sep 2026" on the changelog, "03/09/2026" in admin, and bare ISO in a couple
// of dashboard labels. One helper so they cannot drift again.

const PARIS = 'Europe/Paris';

/**
 * dd/mm/yy. Accepts a bare calendar day ('2026-09-03') or a full timestamp.
 *
 * A bare day is reordered as text rather than pushed through a Date, because
 * parsing 'YYYY-MM-DD' gives UTC midnight and rendering that in another zone
 * can land on the day before. A timestamp is a real moment, so that one is
 * shown in Paris time, matching how the app counts a practice day.
 */
export function formatDate(value) {
    if (!value) return '';
    const day = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value));
    if (day) {
        const [, y, m, d] = day;
        return `${d}/${m}/${y.slice(2)}`;
    }
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return '';
    return d.toLocaleDateString('en-GB', {
        timeZone: PARIS, day: '2-digit', month: '2-digit', year: '2-digit',
    });
}
